module.exports = __webpack_public_path__ + "static/media/tables.ecca6401.svg";